import { useFormContext } from 'react-hook-form';

import { type ProctorRequestCreationFormInput } from './schemas';

function useProctorRequestCreationForm() {
  const context = useFormContext<ProctorRequestCreationFormInput>();

  if (!context) {
    throw new Error(
      'useProctorRequestCreationForm must be used within a ProctorRequestCreationFormProvider',
    );
  }

  return context;
}

export { useProctorRequestCreationForm };
